import { Stack } from '@mui/material'

import {
  Maybe,
  PendingPurchaseItemsConnectionFragment,
} from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { PurchaseItem, PurchaseItemSkeleton } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  loading: boolean
  hasNextPage: boolean
  pendingPurchaseItems: Maybe<PendingPurchaseItemsConnectionFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onFetchMore: () => Promise<void>
}

export const PaymentStatusesTemplate: Template<State, Action> = ({
  state,
  onFetchMore,
}) => {
  const { t } = useTranslation('paymentStatuses')
  const { routerNames, routerPages } = useRouter()
  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.Management,
      }}
    >
      <Head title={routerNames.PaymentStatuses} />
      <ScrollFetcher
        nodes={state.pendingPurchaseItems?.edges.map(({ node }) => (
          <PurchaseItem pendingPurchaseItem={node} key={node.id} />
        ))}
        loading={state.loading}
        hasNextPage={state.hasNextPage}
        onFetchMore={onFetchMore}
        emptyMessage={t('noPayments')}
        loadingComponent={
          <Stack spacing={5}>
            {Array.from(Array(2).keys()).map(key => (
              <PurchaseItemSkeleton key={key} />
            ))}
          </Stack>
        }
      />
    </BaseLayout>
  )
}
